<template>
  <div style="height: 100vh;" class="c-cyan-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div
      class="full-width  container-history top-spacing"
      style="display: flex; justify-content: center; flex-direction: column;"
    >
      <span
        class="desktop mb-10 text-center mt-10"
        style="font-weight: 600; font-size: 24px;"
        >{{ $t("paymentMethod") }}</span
      >
      <div
        v-loading="isLoading"
        v-for="item in paymentMethods"
        v-if="mappingMethods[item.type]"
        :key="item.id"
        style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; background-color: white; margin: 10px 15px; padding: 1rem 15px; border-radius: 10px; min-height: 85px;; height: auto;"
      >
        <div
          @click="mappingMethods[item.type].handler()"
          class="cursor-pointer full-width"
          style="display: flex; flex-direction: row; align-items: center;"
        >
          <img
            :src="item.image"
            style="width: 42px; height: 42px; margin: 10px 7px;"
          />
          <div style="display: flex; flex-direction: column; margin-left: 8px">
            <p style="margin: 0px; font-weight: 700; font-size: large;">
              {{ mappingMethods[item.type].title }}
            </p>
            <p
              v-if="mappingMethods[item.type].showPoint"
              style="margin: 0px; font-weight: 500; font-size: medium;"
            >
              {{ $t("wap.text38") }}:
              <span style="color: blue"
                >{{ formatNumber($store.getters.point) }} VND</span
              >
            </p>
            <p style="margin: 0px; font-weight: 500; font-size: medium;">
              {{ $t("wap.text39") }}:
              <span style="color: chocolate"
                >{{ formatNumber(moneyPaid) }} VND</span
              >
            </p>
            <span
              v-if="mappingMethods[item.type].note"
              class="note-payment-method"
              >{{ mappingMethods[item.type].note }}</span
            >
          </div>
        </div>
        <i
          @click="mappingMethods[item.type].handler()"
          class="el-icon-arrow-right"
          style="font-weight: 700; font-size: larger;"
        ></i>
      </div>
    </div>
    <modal
      class="modal-logout"
      v-if="isShowModal"
      @close="isShowModal = !isShowModal"
    >
      <template slot="header">
        <h4 class="modal-logout-title">{{ $t("wap.text40") }}</h4>
      </template>
      <template slot="body">
        <div class="modal-logout-body">
          <span>{{ $t("wap.text41") }}</span>
        </div>
      </template>

      <template slot="footer">
        <div class="modal-logout-footer mt-10">
          <button
            @click="isShowModal = !isShowModal"
            type="button"
            class="btn btn-outline-primary close"
          >
            {{ $t("wap.text42") }}
          </button>
          <button
            @click="$router.push('/wap/wallet/add-point')"
            type="button"
            class="btn btn-primary logout-form"
          >
            {{ $t("wap.text43") }}
          </button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import { getInfoBooked } from "@/utils/booked";
import { Modal } from "@/components";
import { getToken } from "@/utils/auth";
import GlobalAPI from "@/views/api/wap/global";
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import BankResource from "@/views/api/bank";
import TeeTimeResource from "@/views/api/wap/detail-tee-time";
import { CB_DELIVERY_CODE } from "../../../../constant/contant";

const SERVICE_ID_BIDV = "WG1001";
export default {
  name: "PaymentMethod",
  components: {
    Modal,
    MainNavBarWapV2
  },
  created() {
    // console.log("getInfoBooked___________", getInfoBooked());

    const constMethods = {
      bank: {
        showPoint: false,
        handler: this.handleBank,
        title: this.$t("wap.text122"),
        note: null
      },
      point: {
        showPoint: true,
        handler: this.handlePoint,
        title: this.$t("wap.text130"),
        note: null
      },
      epay_all: {
        showPoint: false,
        handler: this.handleEpay,
        title: this.$t("wap.text131"),
        note: this.$t("wap.text129")
      },
      ale_pay: {
        showPoint: false,
        handler: this.handleAlePay,
        title: this.$t("wap.text184"),
        note: this.$t("wap.text129")
      },
      stb: {
        showPoint: false,
        title: this.$t("wap.text132"),
        handler: this.handlePaySTB,
        note: null
      },
      nab: {
        showPoint: false,
        title: "Nam A Bank",
        handler: this.handlePayNAB,
        note: null
      },
      vietin: {
        showPoint: false,
        title: "Vietinbank",
        handler: this.handlePayVietin,
        note: null
      },
      bidv: {
        showPoint: false,
        title: "BIDV",
        handler: this.handlePayBidv,
        note: null
      }
    };
    this.mappingMethods = constMethods;
    this.getPaymentMethod();
  },
  mounted() {},
  data() {
    return {
      infoHeader: {
        title: this.$t("paymentMethod"),
        isShowHomeIcon: false
      },
      loadingMethod: false,
      isLoading: false,
      idInterval: null,
      isShowModal: false,
      dialogLoginVisible: false,
      transactionVisible: false,
      defaultBackgroundColor: "",
      params: {},
      paymentMethods: [],
      mappingMethods: {},
      transactionData: {},
      moneyPaid: getInfoBooked().payment_amount,
      profile: {},
      dataResult: {},
      typePayment: "point"
    };
  },
  beforeDestroy() {},
  methods: {
    handleCheckStatusPayment(obj) {
      setInfoEpay(obj);
      this.$router.push({ name: "wap-hio-payment-method-epay", params: obj });
    },
    formatNumber: function(number) {
      return new Intl.NumberFormat("vi-VN")
        .format(number)
        .split(".")
        .join(".");
    },
    handleBack() {
      this.$router.go(-1);
    },
    handleBank() {
      this.$router.push("/wap/qr-payment");
    },
    handlePoint() {
      // console.log(
      //   "this.moneyPaid , point",
      //   this.moneyPaid,
      //   this.$store.getters.point
      // );
      if (this.moneyPaid > this.$store.getters.point) {
        this.isShowModal = true;
        return;
      }
      this.typePayment = "point";
      this.dialogLoginVisible = true;
      this.$router.push("/wap/point-payment");
    },
    handleEpay() {
      this.$router.push("/wap/epay-payment");
    },
    handleAlePay() {
      this.$router.push("/wap/alepay-payment");
    },
    handlePayVietin() {
      TeeTimeResource.renderAes256({
        code_booking: CB_DELIVERY_CODE + this.$route.query.id_general_bill
      }).then(res => {
        console.log("res.............renderAes256", res);
        console.log("res.............renderAes256", res.data.url);
        if (res.error_code == 0) {
          // let url = "vhandicap://shop/product_id=6367";
          location.href = res.data.url;
          location.replace(url);
        } else {
          this.$message({
            message: res.data.message,
            type: "error"
          });
        }
      });
    },
    handlePaySTB() {
      console.log("getToken()__________", getToken());
      const body = {
        bilId: this.$route.query.id_general_bill,
        orderId: getToken().order_id
      };
      this.isLoading = true;
      console.log("___________________body", body);
      BankResource.confirm_order_booking_SCB(body)
        .then(res => {
          console.log("res.............renderAes256", res);
          if (res.error_code == 0) {
            this.formConfirmOrderSTB(
              res.data.data,
              res.data.checksum,
              res.data.url
            );
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handlePayNAB() {
      console.log("getToken()__________", getToken());
      const body = {
        bill_id: this.$route.query.id_general_bill,
        is_verify_booking: 1,
        type_purchase: 0,
        bank_id: getToken()?.bank_id,
        user_id: getToken().vga
      };
      this.isLoading = true;
      console.log("___________________body", body);
      BankResource.confirm_booked_bank(body)
        .then(res => {
          console.log("res.............confirm_booked_bank", res);
          if (res.error_code !== 0) {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handlePayBidv() {
      this.isLoading = true;
      TeeTimeResource.encryptDataInquireBidv({
        service_id: SERVICE_ID_BIDV,
        order_id: this.$route.query.id_general_bill
      })
        .then(res => {
          console.log("res.............", res);
          if (res.error_code == 0) {
            location.href = `/wap/payment-method/payment-bidv?data=${res.data.encryptData}`;
            console.log("res.............", res);
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
      // this.$router.push("/wap/");
    },
    formConfirmOrderSTB(data, checksum, url) {
      var form = document.createElement("form");
      var element1 = document.createElement("input");
      var element2 = document.createElement("input");
      form.method = "POST";
      form.action = url;

      element1.value = data;
      element1.name = "data";
      form.appendChild(element1);
      element2.value = checksum;
      element2.name = "checksum";
      form.appendChild(element2);
      document.body.appendChild(form);
      form.submit();
      form.remove();
    },
    getPaymentMethod() {
      this.loadingMethod = true;
      GlobalAPI.list_method_payment({ version: 1 })
        .then(res => {
          const { error_code, data, error_msg } = res;
          if (error_code !== 0) {
            return;
          } else {
            this.paymentMethods = res.data;
          }
        })
        .finally(() => {
          this.loadingMethod = false;
        });
    }
  }
};
</script>
<style></style>
<style scoped>
::v-deep .modal-wrapper .modal-container {
  border-radius: 15px !important;
}
.top-spacing {
  padding-top: 100px;
}
.note-payment-method {
  margin: 0px;
  font-weight: 500;
  font-size: medium;
  color: #e31d1d;
  line-height: 1;
}
::v-deep .el-dialog__wrapper {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100% !important;
}

.modal-logout {
  background: rgba(0, 0, 0, 0.6);
  height: 100vh;
  z-index: 4;
  border-radius: 15px !important;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}
.modal-logout-title {
  font-family: "SF Pro Display";
  font-size: 14px;
  font-weight: 600;
  line-height: 23.87px;
  text-align: center;
  color: #000;
  margin: 0;
}
.modal-logout-body {
  text-align: start;
  color: rgba(153, 153, 153, 1);
  font-family: "SF Pro Display";
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
}

.modal-logout-body-content span {
  font-weight: 500;
  color: #999999;
}
.modal-logout-footer {
  justify-content: center;
  display: flex;
  width: 100%;
}

.modal-logout-footer .close {
  border-radius: 8px;
  border: 1px solid rgba(64, 110, 226, 1);
  width: 50%;
  height: 40px;
  color: rgba(64, 110, 226, 1);
  font-family: "SF Pro Display";
  font-size: 14px;
  font-weight: 600;
  line-height: 16.71px;
  text-align: center;
  margin-right: 20px;
}

.modal-logout-footer .logout-form {
  border-radius: 8px;
  background-color: rgba(64, 110, 226, 1);
  width: 50%;
  height: 40px;
  color: rgb(255, 255, 255);
  font-family: "SF Pro Display";
  font-size: 14px;
  font-weight: 600;
  line-height: 16.71px;
  text-align: center;
}
.modal-logout > footer {
  justify-content: space-between;
  padding: 0;
}
.container-history {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  max-width: 900px;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .top-spacing {
    padding-top: 65px;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>
